// context/AppState.js

import React, { createContext, useReducer, useContext } from 'react';

// 1. Initial State
const initialState = {
    // Initial state for language and country
    language: 'en',
    country: 'za'
};

// 2. Reducer Function
function appReducer(state, action) {
    switch (action.type) {
        case 'SET_LANGUAGE': // Renamed action type for clarity
            return {
                ...state,
                // Correctly update the 'language' property
                language: action.payload, 
            };
        case 'SET_COUNTRY': // Renamed action type for clarity
            return {
                ...state,
                // Correctly update the 'country' property
                country: action.payload,
            };
        default:
            return state;
    }
}

// 3. Create Contexts
// Contexts are created outside the component so they can be imported and used anywhere.
export const AppStateContext = createContext(initialState);
export const AppDispatchContext = createContext(() => {});

// 4. Custom Hook for easy access
// These hooks make consuming the context cleaner in other components.
export const useAppState = () => useContext(AppStateContext);
export const useAppDispatch = () => useContext(AppDispatchContext);

// 5. Provider Component
// This component manages the state and provides it to the component tree.
export function AppProvider({ children }) {
    const [state, dispatch] = useReducer(appReducer, initialState);

    return (
        <AppStateContext.Provider value={state}>
            <AppDispatchContext.Provider value={dispatch}>
                {children}
            </AppDispatchContext.Provider>
        </AppStateContext.Provider>
    );
}